import { fetchApi } from '../../../lib/fetchApi';
import { ExportCSVData } from '../types';

export interface ExportCSVResult {
    filename: string;
    recordCount: number;
}

export const saveAlertsCsv = async (body: ExportCSVData): Promise<ExportCSVResult> => {
    const response = await fetchApi.post('/alert/exportCSV', body, {
        responseType: 'arraybuffer',
        headers: {
            'Content-Type': 'application/json',
        }
    });

    // Response is directly the ArrayBuffer
    const arrayBufferData = response instanceof ArrayBuffer ? response : response.data;

    if (!arrayBufferData) {
        throw new Error('No ArrayBuffer data found in response');
    }

    // Convert ArrayBuffer to text to count lines
    const text = new TextDecoder('utf-8').decode(arrayBufferData);
    const lines = text.split('\n').filter(line => line.trim().length > 0);
    const recordCount = Math.max(0, lines.length - 1); // Subtract header row

    const blob = new Blob([arrayBufferData], {
        type: 'text/csv;charset=utf-8'
    });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;

    const defaultFilename = 'Craiteria_Alertes';
    const now = new Date();
    const dateSuffix = now.toISOString().slice(0, 10).replace(/-/g, "");
    const timeSuffix = now.toISOString().slice(11, 19).replace(/:/g, "");
    const finalFilename = `${defaultFilename}_${dateSuffix}_${timeSuffix}.csv`;

    link.setAttribute('download', finalFilename);
    document.body.appendChild(link);
    link.click();
    link.parentNode?.removeChild(link);
    window.URL.revokeObjectURL(url);

    return {
        filename: finalFilename,
        recordCount: recordCount
    };
};